var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSwiper
        ? [
            _vm.swiperSlides.length > 0
              ? _c(
                  "swiper",
                  {
                    ref: "swiperRef",
                    staticClass: "dynamic-carousel-container",
                    class:
                      ((_obj = {}),
                      (_obj["dynamic-carousel-container--light"] =
                        _vm.isSwiperThemeLight),
                      _obj),
                    attrs: {
                      config: _vm.defaultConfig,
                      pagination: _vm.pagination,
                      navigation: _vm.navigation,
                      "next-navigation": _vm.nextNavigation,
                      "prev-navigation": _vm.prevNavigation,
                    },
                    on: {
                      next: _vm.emitSwiperNext,
                      prev: _vm.emitSwiperPrev,
                      snapIndexChange: _vm.emitSnapIndexChange,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "navigationprev",
                          fn: function () {
                            return [
                              _vm.withNavigationArrows
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        "common__icon common__icon--caret-" +
                                        _vm.arrowColor +
                                        "left",
                                    },
                                    [_vm._v("caret-big-left")]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.translation("swiper.previous"))
                                    ),
                                  ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "navigationnext",
                          fn: function () {
                            return [
                              _vm.withNavigationArrows
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        "common__icon common__icon--caret-" +
                                        _vm.arrowColor +
                                        "right",
                                    },
                                    [_vm._v("caret-big-rights")]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.translation("swiper.next"))
                                    ),
                                  ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4186384346
                    ),
                  },
                  _vm._l(_vm.swiperSlides, function (slot, index) {
                    return _c(
                      "rb-dynamic-swiper-slide",
                      {
                        key: index,
                        attrs: {
                          index: index,
                          "active-slide-index": _vm.snapIndex,
                        },
                      },
                      [_vm._t("default")],
                      2
                    )
                  }),
                  1
                )
              : _c("rb-loading", { attrs: { loading: true } }),
          ]
        : [
            _c(
              "div",
              {
                staticClass: "grid dynamic-grid-container",
                class: [
                  "grid--gap-" + _vm.columnGap,
                  {
                    "grid--auto-col": !_vm.isStackedOnMobile,
                  },
                ],
              },
              _vm._l(_vm.swiperSlides, function (slot, index) {
                return _c(
                  "rb-dynamic-grid-column",
                  {
                    key: index,
                    attrs: {
                      index: index,
                      "is-full-column": _vm.isStackedOnMobile,
                    },
                  },
                  [_vm._t("default")],
                  2
                )
              }),
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }